import React from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarDaysIcon, PencilSquareIcon } from '@heroicons/react/24/outline';

const DateInfoBlocks = () => {
  const [t] = useTranslation();

  return (
    <>
      <div className='flex w-full flex-row items-center gap-2 sm:gap-5'>
        <div className='flex h-full w-4/5 flex-row items-center gap-3 bg-blue-landing py-2 px-4 text-white sm:w-2/4 sm:gap-4'>
          <CalendarDaysIcon className='h-7 w-7 flex-shrink-0 sm:h-10 sm:w-10' aria-hidden='true' />
          <div className='flex flex-col'>
            <p className='text-sm'>{t('welcome.registration_period')}</p>
            <p className='font-sfproBold sm:text-2xl'>02.11.2026-02.04.2027</p>
          </div>
        </div>
      </div>
      <div className='flex w-full flex-row items-center gap-2 sm:gap-5'>
        <div className='flex h-full w-4/5 flex-row items-center gap-3 bg-black-landing py-2 px-4 text-white sm:w-2/4 sm:gap-4'>
          <PencilSquareIcon className='h-7 w-7 flex-shrink-0 sm:h-10 sm:w-10' aria-hidden='true' />
          <div className='flex flex-col'>
            <p className='text-sm'>{t('welcome.exam_date')}</p>
            <p className='font-sfproBold sm:text-2xl'>02.05.2027</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DateInfoBlocks;
